<!--
 * @Description:
 * @Version: 2.0
 * @Autor: dudedu
 * @Date: 2022-10-28 10:01:39
 * @LastEditors: dudedu
 * @LastEditTime: 2024-01-23 19:17:29
-->
<template>
  <div class="index">
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { postRequest, getRequest } from '@/common/libs/request';
import {
  PATH_WORKBENCH,
  LOGIN_PATH_WORKBENCH,
  TEST_DEV_ENV,
  TEST_ENV,
  TEST_STAGING_ENV,
  LOGIN_PATH_MAP
} from '@/common/constants';
import Cookies from 'js-cookie';

export default {
  name: 'App',
  components: {
  },
  computed: {
    ...mapState(['app']),
  },
  async created() {
    const { code, state } = this.$route.query;
    if (code) {
      // 如果是测试环境，那么直接跳转到测试环境
      if (state === 'qqtest') {
        window.location = `https://${TEST_ENV}?code=${code}&state=qq&isTestEnv=1`;
        return false;
      }
      // 开发环境
      if (state === 'qqdev') {
        window.location = `https://${TEST_DEV_ENV}?code=${code}&state=qq&isDevEnv=1`;
        return false;
      }
      // staging
      if (state === 'qqstaging') {
        window.location = `https://${TEST_STAGING_ENV}?code=${code}&state=qq&isDevEnv=1`;
        return false;
      }
      // 云登录
      if (!["cloud", "qq"].includes(state)) {
        const url = LOGIN_PATH_WORKBENCH[state];
        const skey = Cookies.get('skey');
        const uin = Cookies.get('uin');
        const encodeCode = `${skey}|${uin}`;
        window.location = `https://${url}?code=${encodeURIComponent(encodeCode)}&state=cloud&isTestEnv=1`;
        return false;
      }
      // 开发/测试环境腾讯云登录
      if (["cloud", "qq"].includes(state) && LOGIN_PATH_MAP.includes(window.location.host)) {
        // [TEST_ENV, TEST_DEV_ENV, TEST_STAGING_ENV].includes(window.location.host)
        const parseCode = decodeURIComponent(code);
        const params = parseCode.split('|');
        // 将skey转移到开发/测试环境
        if (params.length === 2) {
          const skey = params[0];
          const uin = params[1];
          Cookies.set('skey', skey, { expires: 0.1 });
          Cookies.set('uin', uin, { expires: 0.1 });
        }
      }

      // 跳转登录
      await this.login(code, state);
    } else {
      await this.getUserInfo();
    }
  },
  methods: {
    // 登录
    async login(code, state) {
      try {
        await postRequest('/api/common/login', {
          code,
          redirectUri: encodeURI(PATH_WORKBENCH),
          state: state || 'qq',
        });

        window.sessionStorage.setItem('loginType', state);
        window.sessionStorage.removeItem('menuIndex');
        window.sessionStorage.removeItem('currentProject');
        window.sessionStorage.removeItem('projectName');
        Cookies.remove('CurrentProjectId');

        await this.$router.replace({
          name: 'dashboard',
        });
      } catch (e) {
        await this.$router.replace({
          name: 'login',
        });
      }
    },

    // 校验用户是否已经登录
    async getUserInfo() {
      const res = await getRequest('/api/eda/common/eda/getUserInfo');
      if (res.userId) {
        await this.$router.replace({
          name: 'dashboard',
        });
      } else {
        await this.$router.replace({
          name: 'login',
        });
      }
    },
  },
};
</script>

<style scoped>

</style>
